import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";
import Login from "@/pages/Login";
import AdPerformance from "@/pages/AdPerformance";
import PlayReviews from "@/pages/PlayReviews";
import Reports from "@/pages/Reports";
import RodbezFlow from "@/pages/RodbezFlow";
import Invoice from "@/pages/Invoice";
import MissedCalls from "@/pages/MissedCalls";
import BotHealth from "@/pages/BotHealth";
import BotManagement from "@/pages/BotManagement";
import BlockedCustomers from "@/pages/BlockedCustomers";
import Customers from "@/pages/Customers";
// Per user rule 2026-02-14 — VoiceTestCall import kept (compiles fine
// since unused imports are tree-shaken). Route + nav are commented out
// for now ("baad me dekhenge"). Uncomment in App.js to re-enable.
// eslint-disable-next-line no-unused-vars
import VoiceTestCall from "@/pages/VoiceTestCall";
import { BotEditorPage } from "@/components/hub/BotsDialog";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import ErrorBoundary from "@/components/ErrorBoundary";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="h-screen grid place-items-center text-sm text-[var(--muted)]">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="h-screen grid place-items-center text-sm text-[var(--muted)]">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <ErrorBoundary>
            <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bots/:botId"
              element={
                <AdminRoute>
                  <BotEditorPage />
                </AdminRoute>
              }
            />
            <Route
              path="/ad-performance"
              element={
                <AdminRoute>
                  <AdPerformance />
                </AdminRoute>
              }
            />
            <Route
              path="/play-reviews"
              element={
                <ProtectedRoute>
                  <PlayReviews />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <Reports />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rodbez-flow"
              element={
                <ProtectedRoute>
                  <RodbezFlow />
                </ProtectedRoute>
              }
            />
            <Route
              path="/invoice"
              element={
                <ProtectedRoute>
                  <Invoice />
                </ProtectedRoute>
              }
            />
            <Route
              path="/missed-calls"
              element={
                <ProtectedRoute>
                  <MissedCalls />
                </ProtectedRoute>
              }
            />
            {/* Per user rule 2026-02-14 — /voice-test temporarily hidden
                ("abhi hata dijiye, baad me dekhenge"). VoiceTestCall.jsx
                + backend endpoints (/api/tata/voice-test-call, /tts-preview,
                /dialplan) all intact — uncomment this block to re-enable. */}
            {/*
            <Route
              path="/voice-test"
              element={
                <AdminRoute>
                  <VoiceTestCall />
                </AdminRoute>
              }
            />
            */}
            <Route
              path="/bot-health"
              element={
                <ProtectedRoute>
                  <BotHealth />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bot-management"
              element={
                <ProtectedRoute>
                  <BotManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/blocked-customers"
              element={
                <AdminRoute>
                  <BlockedCustomers />
                </AdminRoute>
              }
            />
            <Route
              path="/customers"
              element={
                <ProtectedRoute>
                  <Customers />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </ErrorBoundary>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
